module.exports = __webpack_public_path__ + "static/media/folha2.5a8e0e5b.png";